var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D35BC",
    fillRule: "evenodd",
    d: "M2.571.5A2.571 2.571 0 0 0 0 3.071V15.93A2.571 2.571 0 0 0 2.571 18.5H15.43A2.571 2.571 0 0 0 18 15.929V3.07A2.571 2.571 0 0 0 15.429.5H2.57Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M2.57 10.786h2.572l2.571-6.429 3.215 10.929L12.213 9.5h3.215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity-icon.dd05aa349ba688b5712330bda06a29f7.svg";
export { ForwardRef as ReactComponent };